// eslint-disable-next-line angular/factory-name
angular.
module("digiexam.exam").
factory("FinalGrade", function finalGradeService() {
	"use strict";

	var defaults = {
		examId: null, // Int
		studentId: null, // Int
		grade: "",
		note: "",
		finalGradeType: 0,
	};

	function FinalGrade(data) {
		angular.extend(this, defaults);

		if (data) {
			angular.extend(this, data);
		}

		this.cacheId = "FinalGrade-" + this.examId + "-" + this.studentId;
	}

	FinalGrade.prototype.isGraded = function isGraded() {
		return !!this.grade && typeof this.grade === "string";
	};

	return FinalGrade;
});
